import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {STATUS_ICON_CONFIG_MAP} from '@theme/components/ui/status/status-icon-config';

@Component({
    selector: 'ngx-status',
    template: `
        <div class="status-cell" *ngIf="icon && iconStatus">
            <span class="leader-text" [ngClass]="[iconStatus]" *ngIf="iconLeadLabel">{{ iconLeadLabel }}</span>
            <span class="icon-wrapper" [ngClass]="[iconStatus]" *ngIf="!iconLeadLabel">
                <nb-icon pack="eva" [icon]="icon"></nb-icon>
            </span>
            <span class="icon-inverter" [ngClass]="[iconStatus]" *ngIf="iconLeadLabel" onClick="onLeadIconClick.emit()">
                <nb-icon pack="eva" [icon]="icon"></nb-icon>
            </span>
            <span class="status-label" *ngIf="iconLabel">{{ iconLabel }}</span>
        </div>
    `,
    styleUrls: ['./status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusComponent implements OnChanges {
    icon: string;
    iconStatus: string;
    iconLabel: string;
    /** inverts the icon background colour with foreground color */
    @Input() invertIconColour: boolean = false;
    /** text label to place ahead of the icon */
    @Input() iconLeadLabel: string;

    @Input() status: string;
    //On Lead Icon Clicked.
    @Output() onLeadIconClick?: EventEmitter<any> = new EventEmitter();

    constructor() {}

    ngOnChanges(): void {
        const config = STATUS_ICON_CONFIG_MAP[this.status] || {
            icon: 'close-circle-outline',
            status: 'basic',
            label: 'unknown',
        };

        this.icon = config.icon;
        this.iconStatus = config.status;
        this.iconLabel = config.label;
    }
}
